
const experience = [
    {
        id: 1,
        logo: '',
        company: 'Edstem Technologies',
        role: 'Software Engineer',
        date: 'Jan 2024 - Present',
        desc: 'At Edstem, I build scalable React UIs, translating designs into responsive interfaces. Contributed to K-SMART and TDMS with reusable components and clean API integrations.'
    },
    {
        id: 2,
        logo: '',
        company: 'A2S Software Solutions',
        role: 'Software Engineer',
        date: 'Jun 2022 - Oct 2023',
        desc: 'At A2S Software Solutions, I worked on an e-commerce site and a doctor consultation app, while also training students in MERN stack development. Gained hands-on experience in both front-end and back-end.'
    },
    {
        id: 3,
        logo: '',
        company: 'PerfAgents',
        role: 'Software Engineer',
        date: 'Apr 2021 - Mar 2022',
        desc: 'At PerfAgents, I developed user-friendly apps using low-code tools like Unqork. Helped the team earn platform certification, while gaining hands-on experience with agile workflows and SDLC practices'
    }
]

export default experience;
